import { HashConnect } from 'hashconnect'
import { verify, getAuth, getTokens, getManceTokens, notifyAssociation, notifyManceAssociation, redeemToken} from '../services/API'
import { makeBytes } from '../Helpers/helpers';

import {
    TransactionId,
    TokenAssociateTransaction,
    TransferTransaction,
    TokenDissociateTransaction,
    AccountId,
    AccountAllowanceApproveTransaction,
    NftId,
    TokenId
} from '@hashgraph/sdk';

import updateUserData from '../Redux/updateUser';
import getUserId from '../Redux/getUser';
import updateWalletData from '../Redux/updateWallet';
import { BASE_URL, NETWORK } from '../Utils';


let hashconnect = new HashConnect()

const appMetadata = {
    name: "RantCPU",
    description: "RantCPU Digital Cards is a collection of digital artworks (NFTs) running on the Hedera network. This website is only an interface allowing participants to purchase digital collectibles.",
    icon: "https://liith.org/rantcpusizzle/assets/images/logo_RantCPU_white.png",
    url: BASE_URL
}

 

export const initConnection = async () => {
    let initData = await hashconnect.init(appMetadata, NETWORK, false);
    return initData;
}

export async function manualListener(setLoading, setIsConnecting, setConnectWindowOpen) {
    hashconnect.pairingEvent.once(async(pairingData) => {
       await  authenticateUser(pairingData, setLoading)
       setIsConnecting(false)
       setConnectWindowOpen(false)
       setLoading(false)
    })
}

export const disconnect = async () => {
    try {
        let initData = await initConnection();
        let topic = initData.topic;
        await hashconnect.disconnect(topic)
        await hashconnect.clearConnectionsAndData()
        localStorage.clear();
        window.location.reload();
    } catch (error) {

    }
}

export const associate = async (setIsAssociationSuccessful) => {
    try {
        let initData = await initConnection();
        const topic = initData.topic;
        const accountId = getUserId()
        const tokenIds = await getTokens();
        let transId = TransactionId.generate(accountId)
        const tx = new TokenAssociateTransaction()
            .setAccountId(accountId)
            .setTokenIds(tokenIds)
            .setNodeAccountIds([new AccountId(3)])
            .setTransactionId(transId)
            .freeze()
        let transBytes = await makeBytes(tx);
        const transaction = {
            topic: topic,
            byteArray: transBytes,
            metadata: {
                accountToSign: accountId,
                returnTransaction: false,
                hideNft: false
                }
            }

        const res = await hashconnect.sendTransaction(topic, transaction);
        if(res.success===true){
            setIsAssociationSuccessful(true)
        }

    } catch (error) {

    }
}

export const associateCard = async () => {
    try {
        let initData = await initConnection();
        const topic = initData.topic;
        const accountId = getUserId()
        let transId = TransactionId.generate(accountId)
        const tx = new TokenAssociateTransaction()
            .setAccountId(accountId)
            .setTokenIds(["0.0.4690074"])
            .setNodeAccountIds([new AccountId(3)])
            .setTransactionId(transId)
            .freeze()
        let transBytes = await makeBytes(tx);
        const transaction = {
            topic: topic,
            byteArray: transBytes,
            metadata: {
                accountToSign: accountId,
                returnTransaction: false,
                hideNft: false
                }
            }

        const res = await hashconnect.sendTransaction(topic, transaction);
        if(res.success===true){
            return true;
        }

    } catch (error) {

    }
}

export const associateFT = async (setIsClaimSuccessful) => {
    try {
        let initData = await initConnection();
        const topic = initData.topic;
        const accountId = getUserId()
        const tokenIds = await getTokens();
        let transId = TransactionId.generate(accountId)
        const tx = new TokenAssociateTransaction()
            .setAccountId(accountId)
            .setTokenIds(tokenIds)
            .setNodeAccountIds([new AccountId(3)])
            .setTransactionId(transId)
            .freeze()
        let transBytes = await makeBytes(tx);
        const transaction = {
            topic: topic,
            byteArray: transBytes,
            metadata: {
                accountToSign: accountId,
                returnTransaction: false,
                hideNft: false
                }
            }

        const res = await hashconnect.sendTransaction(topic, transaction);
        if(res.success===true){
            notifyAssociation();
            setIsClaimSuccessful(true)
        }
    } catch (error) {

    }
}


export const associateFTMance = async (setIsClaimSuccessful) => {
    try {
        let initData = await initConnection();
        const topic = initData.topic;
        const accountId = getUserId()
        const tokenIds = await getManceTokens();
        let transId = TransactionId.generate(accountId)
        const tx = new TokenAssociateTransaction()
            .setAccountId(accountId)
            .setTokenIds(tokenIds)
            .setNodeAccountIds([new AccountId(3)])
            .setTransactionId(transId)
            .freeze()
        let transBytes = await makeBytes(tx);
        const transaction = {
            topic: topic,
            byteArray: transBytes,
            metadata: {
                accountToSign: accountId,
                returnTransaction: false,
                hideNft: false
                }
            }

        const res = await hashconnect.sendTransaction(topic, transaction);
        if(res.success===true){
            notifyManceAssociation();
            setIsClaimSuccessful(true)
        }
    } catch (error) {

    }
}

// export const getAllowance = async (token ) => {
//     try {
       
//             let initData = await initConnection();
//             const topic = initData.topic;
//             const id = await getUserId()
//             const accountId = AccountId.fromString(id)
//             const tokenId = await TokenId.fromString(token.token_id)
            
//             const nft = new NftId (tokenId, token.serial_number);
//             const nft2approve = [nft];
//             let transId = TransactionId.generate(accountId)
//             const tx = await new AccountAllowanceApproveTransaction()
//             .approveTokenNftAllowance(nft2approve[0], id, "0.0.448903")
//             .setNodeAccountIds([new AccountId(3)])
//             .setTransactionId(transId)
//             .freeze()
//             let transBytes = await makeBytes(tx);
//             const transaction = {
//                topic: topic,
//                byteArray: transBytes,
//                metadata: {
//                    accountToSign: accountId,
//                    returnTransaction: false,
//                    hideNft: false
//                 }
//             }

//         const res = await hashconnect.sendTransaction(topic, transaction);
//         console.log(res)

//     } catch (error) {
//        console.log(error)
//     }
// }



export const disassociate = async (setIsAssociationSuccessful) => {
    try {
        let initData = await initConnection();
        const accountId = getUserId()
        const topic = initData.topic;
        const tokenIds = await getTokens();
        let transId = TransactionId.generate(accountId)
        const tx  = new TokenDissociateTransaction()
            .setAccountId(accountId)
            .setTokenIds(tokenIds)
            .setNodeAccountIds([new AccountId(3)])
            .setTransactionId(transId)
            .freeze()
        let transBytes = await makeBytes(tx);
        const transaction = {
            topic: topic,
            byteArray: transBytes,
            metadata: {
                accountToSign: accountId,
                returnTransaction: false,
                hideNft: false
            }
        }
        let res = await hashconnect.sendTransaction(topic, transaction);
        setIsAssociationSuccessful(true)
        // console.log(res)
    } catch (error) {

    }
}

export const signTransaction = async (transBytes) => {
    // console.log(transBytes)
    try {
        let initData = await initConnection();
        const topic = initData.topic;
        const accountId = getUserId()
        const provider = hashconnect.getProvider(NETWORK, topic, accountId)
        const signer = hashconnect.getSigner(provider)
        const tx = TransferTransaction.fromBytes(transBytes.data)
        const submit = await tx.executeWithSigner(signer)
        if (submit) {
            return true
        } else {
            return false;
        }
    } catch (error) {
      console.log(error)
    }
}

export const pairHashpack = async (setLoading) => {
    try {
   
        let initData = await initConnection();
        
        hashconnect.foundExtensionEvent.once((walletMetadata) => {
          
          hashconnect.connectToLocalWallet(initData.pairingString, walletMetadata);
        
        }) 
        
        hashconnect.foundIframeEvent.once((walletMetadata) => {
            hashconnect.connectToLocalWallet(initData.pairingString, walletMetadata);
        })


    } catch (error) {
    // console.log(error)
    }
}


export const initRedeem = async (token) => {
    try {
    //   console.log("init")
    //   let initData = await initConnection();
    //   const accountId = getUserId()
    //   const topic = initData.topic;
    //   let transId = TransactionId.generate(accountId)
    //   const provider = hashconnect.getProvider(NETWORK, topic, accountId)
    //   const signer = hashconnect.getSigner(provider)
    //   console.log(signer)
    //     let tokenTransferTx = 
    //     await new TransferTransaction()
    //                     .addNftTransfer(token.token_id, token.serial_number, accountId, "0.0.3821765")
    //                     .setTransactionId(transId)
    //                     .setNodeAccountIds([new AccountId(3)])
    //                     .freeze();
    //                     const signed = await tokenTransferTx.sign(signer)
    //     //  let response = await tokenTransferTx.signTransaction(signer)
    //     // let response = await hashconnect.signAndMakeBytes(tokenTransferTx);
    //     // const signed = await tokenTransferTx.sign(topic, accountId, tokenTransferTx);
    //     console.log(signed)
        // let transBytes = await makeBytes(signed);


     const tx =  await redeemToken(token.token_id, token.serial_number)
        return tx;
    } catch (error) {
        
    }
}


export const aaa = async (setIsAssociationSuccessful) => {
    try {
        let initData = await initConnection();
        const accountId = getUserId()
        const topic = initData.topic;
        const tokenIds = await getTokens();
        let transId = TransactionId.generate(accountId)
        const tx  = new TokenDissociateTransaction()
            .setAccountId(accountId)
            .setTokenIds(tokenIds)
            .setNodeAccountIds([new AccountId(3)])
            .setTransactionId(transId)
            .freeze()
        let transBytes = await makeBytes(tx);
        const transaction = {
            topic: topic,
            byteArray: transBytes,
            metadata: {
                accountToSign: accountId,
                returnTransaction: false,
                hideNft: false
            }
        }
        let res = await hashconnect.sendTransaction(topic, transaction);
        setIsAssociationSuccessful(true)
        // console.log(res)
    } catch (error) {

    }
}

export const authenticateUser = async (pairingData,    setLoading) => {
    try {
        setLoading(true)
        const res = await getAuth();
        setLoading(false)
        const signingData = res.payload
        const serverSigAsArr = Object.values(signingData.serverSignature)
        const serverSigAsBuffer = Buffer.from(serverSigAsArr)
        setLoading(true)
        const auth = await hashconnect.authenticate(pairingData.topic, pairingData.accountIds[0], signingData.serverSigningAccount, serverSigAsBuffer, signingData.payload);
        if(auth.success===true){
        setLoading(false)
        const receiveAuthData = {
            signingAccount: pairingData.accountIds[0],
            auth
        }
        setLoading(true)
        const verificationData = JSON.stringify(receiveAuthData);
        const verification = await verify(verificationData);
        
        if (verification.message === 'Success' && verification.payload !== 'This account does not exist') {
            updateUserData(pairingData.accountIds[0], verification.payload, true)
            localStorage.setItem("accessToken", verification.payload.token)
        }else if(verification.payload !== 'This account does not exist'){
         updateWalletData(true)
        }
    }
        setLoading(false)
    
    } catch (error) {
        // console.log(error)
    }
}

 